import { render, staticRenderFns } from "./MigrationNoticeModal.vue?vue&type=template&id=48a9a21c&scoped=true&"
import script from "./MigrationNoticeModal.vue?vue&type=script&lang=js&"
export * from "./MigrationNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./MigrationNoticeModal.vue?vue&type=style&index=0&id=48a9a21c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9a21c",
  null
  
)

export default component.exports